/**
 * Team credits — mostrato nel modale "Credits" cliccando sul logo
 * Diakonix in sidebar. Aggiornare qui quando entra/esce un dev.
 *
 * `role` viene renderizzato come pill colorata (variante da
 * `roleVariant`); `since` è un semplice anno di ingresso; il
 * dev con `maintainer: true` viene evidenziato con un badge
 * dedicato nel modale.
 */

export interface TeamMember {
  /** Nome visualizzato (formato libero — nome breve o nome completo). */
  name: string;
  /** Ruolo funzionale. */
  /** Categoria del ruolo, usata per la variante colore della pill. */
  roles: {
    label: string;
    variant: 'frontend' | 'backend' | 'fullstack' | 'design' | 'pm' | 'qa';
  }[];
  /** Anno di ingresso nel progetto. */
  since: number;
  /**
   * Flag "sole maintainer" — mostra un badge speciale nel modale.
   * Usare con parsimonia: normalmente 0 o 1 membro attivo, mai più.
   */
  maintainer?: boolean;
}

/**
 * Team attuale di Diakonix.
 *
 * Ordine di visualizzazione: maintainer prima, poi frontend, poi
 * backend, poi altri ruoli. Alfabetico all'interno di ogni gruppo.
 */
export const TEAM_CREDITS: readonly TeamMember[] = [
  {
    name: 'Gabriele Tambellini',
    roles: [
    {
      label: 'Frontend Developer',
      variant: 'frontend'
    },
    {
      label: 'UX/UI Designer',
      variant: 'design'
    },
  ],
    since: 2022,
    maintainer: true,
  },
  {
    name: 'Alexandru Florea',
    roles: [
    {
      label: 'Frontend Developer',
      variant: 'frontend'
    },
  ],
    since: 2023,
  },
  {
    name: 'Camelia Botezatu',
    roles: [
      {
        label: 'Frontend Developer',
        variant: 'frontend'
      }
    ],
    since: 2022,
  },
  {
    name: 'Robert Bodolica',
    roles: [
      {
        label: 'Backend Developer',
        variant: 'backend'
      }
    ],
    since: 2025,
  },
] as const;

/** Anno di nascita del progetto (usato come "progetto attivo dal ..."). */
export const PROJECT_INCEPTION_YEAR = 2022;
